// ** react imports
import React, { useEffect } from 'react';

// ** sentry imports
import * as Sentry from "@sentry/react";

// ** react router imports
import { useLocation } from 'react-router-dom';

import './css/style.css';

// ** react toastify imports
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ** theme import
import { useThemeProvider } from './contexts/ThemeContext';

// ** routes imports
import AppRoutes from './routes';

// ** Document API Integration
import './utils/DocumentAPIIntegration';

function App() {
  // hooks
  const location = useLocation();
  const { currentTheme } = useThemeProvider();

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html').style.scrollBehavior = '';
  }, [location.pathname]);

  return (
    <div className="">
      <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <AppRoutes />
      </Sentry.ErrorBoundary>

      <ToastContainer
        theme={currentTheme}
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
